<template>
    <div>
        <div class="signing-top">
            <div class="top">
                <div class="logo">
                    <Logo></Logo>
                </div>
                <div class="content">
                    <h1>{{ $t('review-sign.contract.headline') }}</h1>
                    <p>{{ getSigningPropertyAddress }}</p>
                </div>

                <router-link class="button purple" :to="{name: 'contracts'}">{{
                        $t('button.cancel.label')
                    }}
                </router-link>

            </div>
            <div class="progress-bar">
                <div class="content">
                    <div class="col done">
                        <div class="dot">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9.895" height="7.38"
                                 viewBox="0 0 19.79 14.76">
                                <path class="fill-white"
                                      d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z"
                                      transform="translate(-1311.12 -1083.12)"/>
                            </svg>
                        </div>
                        <p>{{ $t('review-sign.steps.info') }}</p>
                    </div>
                    <div class="col done">
                        <div class="dot">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9.895" height="7.38"
                                 viewBox="0 0 19.79 14.76">
                                <path class="fill-white"
                                      d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z"
                                      transform="translate(-1311.12 -1083.12)"/>
                            </svg>
                        </div>
                        <p>{{ $t('review-sign.steps.review') }}</p>
                    </div>
                    <div class="col done" v-if="isPowerSupplyEnabled">
                        <div class="dot">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9.895" height="7.38"
                                 viewBox="0 0 19.79 14.76">
                                <path class="fill-white"
                                      d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z"
                                      transform="translate(-1311.12 -1083.12)"/>
                            </svg>
                        </div>
                        <p>{{$t('review-sign.steps.electricity') }}</p>
                    </div>
                    <div class="col active">
                        <div class="dot"></div>
                        <p>{{ $t('review-sign.steps.sign') }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="signing-content">
            <div class="content-box small">
                <div>
                    <h2>{{ $t('review-sign.sign.headline') }}</h2>

                    <div v-if="showSignOptions" class="choose-signing-type">
                        <!-- Radio buttons to choose signing method. NemID is chosen by default -->
                        <input type="radio" id="nemid" value="nemid" v-model="signingMethod">
                        <label for="nemid" class="choose-btn nemid">
                            <div>
                                <div class="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="222.485" height="50"
                                         viewBox="0 0 444.97 100">
                                        <path fill="#1c073e"
                                              d="M2031.05,1011.37a3.541,3.541,0,1,0,7.07,0V919.733a3.541,3.541,0,1,0-7.07,0v91.637Zm61.86-4.04h-19.16c-2.72,0-3.54-1.12-3.54-4.19v-75.3c0-3.07.82-4.179,3.54-4.179h18.22c28.94,0,42.67,17.433,42.67,41.827,0,25.1-15.22,41.843-41.73,41.843m0.42-90.651h-21.75c-5.71,0-8.45,3.059-8.45,9.332v78.949c0,6.27,2.74,9.34,8.45,9.34h20.53c31.11,0,49.89-20.353,49.89-49.521,0-29.271-18.36-48.1-48.67-48.1m-389.52,11.157c0-2.516.69-3.07,1.63-3.07,0.96,0,1.77,1.54,2.18,2.084l52.61,81.86c1.24,1.82,3.28,4.88,8.03,4.88,5.18,0,7.89-3.75,7.89-9.48V919.879c0-2.515-1.63-3.768-3.39-3.768-1.78,0-3.4,1.253-3.4,3.768v83.261c0,2.53-.69,3.07-1.64,3.07s-1.76-1.53-2.17-2.1l-52.61-81.86c-1.23-1.817-3.28-4.886-8.04-4.886-5.17,0-7.88,3.757-7.88,9.486v84.53a3.411,3.411,0,1,0,6.79,0V927.836Zm171.03,83.534a3.41,3.41,0,0,0,3.41,3.75c1.77,0,3.39-1.24,3.39-3.75V927.135c0-2.515.55-3.069,1.5-3.069s1.91,1.54,2.32,2.094l29.37,42.412a3.366,3.366,0,0,0,2.97,1.8,3.41,3.41,0,0,0,3-1.8l29.65-42.412c0.39-.554,1.34-2.094,2.3-2.094,0.94,0,1.48.554,1.48,3.069v84.235a3.4,3.4,0,0,0,3.42,3.75c1.76,0,3.38-1.24,3.38-3.75V925.893c0-5.729-2.57-9.219-7.74-9.219-4.75,0-6.66,2.772-8.17,4.866l-27.18,39.784-27.19-39.784c-1.36-1.94-3.27-4.866-8-4.866-5.18,0-7.91,3.767-7.91,9.486v85.21Zm-43.78-48.415a3.478,3.478,0,0,0,4.86.031c1.43-1.437,1-3.686-.34-5.092l-26.79-29.23c-1.5-1.653-2.05-2.361-2.05-3.347s0.68-1.663,2.17-1.663h41.61c2.45-.144,3.69-1.694,3.69-3.491a3.4,3.4,0,0,0-3.69-3.48h-43.51c-4.76,0-8.03,2.5-8.03,6.827,0,4.045,2.86,7.249,5.31,9.9Zm27.5,37.785a3.623,3.623,0,0,0-.95-5.111,3.364,3.364,0,0,0-4.85,1.232c-1.59,2.1-8.55,12.139-24.11,12.139-12.22,0-25.55-7.42-25.55-23.3,0-13.983,13.29-20.092,15.7-21.221,2.28-1.109,2.68-3.132,1.82-4.784-0.82-1.6-2.5-2.464-4.8-1.448-3.58,1.252-19.83,8.86-19.83,27.741,0,18.541,14.55,30,31.84,30,15.83,0,26.45-7.7,30.73-15.25"
                                              transform="translate(-1697.03 -916)"/>
                                    </svg>
                                </div>
                                <span>{{ $t('review-sign.sign.nemid') }}</span>
                            </div>
                        </label>
                        <input v-if="getSingleDraftContract.power_supply_mode === 'manual'" type="radio" id="signature" value="esignature" v-model="signingMethod">
                        <label v-if="getSingleDraftContract.power_supply_mode === 'manual'" for="signature" class="choose-btn">
                            <span>{{$t('review-sign.sign.esignature')}}</span>
                        </label>
                        <div class="custom-checkbox" v-if="getSingleDraftContract.power_supply_mode === 'simplex'">
                            <input type="checkbox" id="acceptTerms" v-model="acceptTerms">
                            <label for="acceptTerms" class="checkbox">
                                <svg xmlns="http://www.w3.org/2000/svg"  width="9.895" height="7.38" viewBox="0 0 19.79 14.76">
                                    <path class="fill-checkmark" d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z" transform="translate(-1311.12 -1083.12)"/>
                                </svg>
                            </label>
                            <p>
                                <label for="acceptTerms">{{$t('review-sign.sign.accept-terms1') }}</label>
                                <a @click.stop="showTerms=true">{{$t('review-sign.sign.terms-link') }}</a>
                            </p>
                         </div>
                        <button v-if="signingMethod == 'nemid'" class="purple" :disabled="!acceptTerms && getSingleDraftContract.power_supply_mode === 'simplex'" @click.prevent="sign('nemid')">{{$t('button.continue') }}</button>
                        <button v-else class="purple" @click.prevent="sign('esignature')" :disabled="!acceptTerms && isPowerSupplyEnabled && getSingleDraftContract.power_supply_mode === 'simplex'">{{$t('button.continue') }}</button>
                    </div>

                    <div v-if="showSignatureField">
                        <SignatureField></SignatureField>
                    </div>

                    <div class="nemid-container" v-if="showNemId">
                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Nøglekort">
                                <nemid-signature
                                    id="nemid_iframe"
                                    v-if="jsConfig"
                                    width="200"
                                    height="280"
                                    :src="nemid_js_endpoint"
                                    :config="jsConfig"
                                    :show-loader="true"
                                    @success="signed"
                                    @error="error"
                                >
                                    <template v-slot:loader>
                                        <loader></loader>
                                    </template>
                                </nemid-signature>
                            </tab>

                            <tab name="Nøglefil">
                                <nemid-signature
                                    id="codefile_iframe"
                                    v-if="cfConfig"
                                    width="300"
                                    height="150"
                                    :src="nemid_cf_endpoint"
                                    :config="cfConfig"
                                    :show-loader="true"
                                    @success="signed"
                                    @error="error"
                                >
                                    <template v-slot:loader>
                                        <loader></loader>
                                    </template>
                                </nemid-signature>
                            </tab>
                        </tabs>
                    </div>
                    <div v-if="showCancelSignOptions">
                        <div class="back-container" @click.prevent="sign('')">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="5.895" height="9.895"
                                     viewBox="0 0 11.79 19.79">
                                    <path class="fill-purple"
                                          d="M3256.31,2083.51l-6.48,6.49,6.48,6.49a1.994,1.994,0,0,1-2.82,2.82l-7.8-7.8a2.256,2.256,0,0,1,0-3.02l7.8-7.8A1.994,1.994,0,0,1,3256.31,2083.51Z"
                                          transform="translate(-3245.12 -2080.12)"/>
                                </svg>
                            </div>
                            <p>{{ $t('review-sign.sign.select-method') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

         <Modal id="showTerms" v-if="showTerms">
            <div slot="modal-container" class="creating-modal-container">
                <div class="modal-wrapper">
                    <div class="modal-container creating-modal with-text">
                        <div class="modal-header">
                            <div class="close" v-on:click="showTerms=false">
                                <svg xmlns="http://www.w3.org/2000/svg" width="11.891" height="11.891" viewBox="0 0 23.781 23.781">
                                  <path class="fill-grey" d="M382.829,147l8.485,8.485a2,2,0,0,1-2.829,2.829L380,149.829l-8.485,8.485a2,2,0,0,1-2.829-2.829L377.172,147l-8.486-8.485a2,2,0,0,1,2.829-2.829L380,144.172l8.485-8.486a2,2,0,0,1,2.829,2.829Z" transform="translate(-368.125 -135.125)"/>
                                </svg>
                            </div>
                            <h2>{{$t('modal.sign-terms.headline') }}</h2>
                        </div>
                        <div class="modal-content">
                            <div v-html="power_supply_terms_and_conditions">

                            </div>
                            <button class="purple" v-on:click="showTerms=false">{{$t('button.close.label')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>
<script>


import SignatureField from './parts/SignatureField';
import {mapGetters} from "vuex";
import Logo from '../../components/Logo';
import NemidSignature from "../../vue-nemid/components/NemidSignature";
import Loader from "../../components/Loader";

export default {

    data: () => ({
        draftContractId: false,
        showNemId: false,
        nemidResponse: '',
        nemid_js_endpoint: window.config.nemid_js_endpoint,
        jsConfig: {},
        nemid_cf_endpoint: window.config.nemid_cf_endpoint,
        cfConfigL: {},
        showSignatureField: false,
        showSignOptions: true,
        showCancelSignOptions: false,
        signingMethod: 'nemid',
        acceptTerms: false,
        showTerms: false,
        role_id: 2,
        power_supply_terms_and_conditions: '',
    }),
    components: {
        Loader,
        NemidSignature,
        SignatureField,
        Logo
    },
    computed: {

        ...mapGetters([
            'getToken',
            'getSigningPropertyAddress',
            'isPowerSupplyEnabled',
            'getSingleDraftContract'
        ]),

    },
    watch: {},
    methods: {
        sign(flow) {
            switch (flow) {
                // Cancel
                case '':
                    this.showSignatureField = false;
                    this.showNemId = false;
                    this.showSignOptions = true;
                    this.showCancelSignOptions = false;
                    break;
                case 'esignature':
                    this.showSignatureField = true;
                    break;
                case 'nemid':
                    this.showNemId = true;
                    break;
            }
            if (flow) {
                this.showSignOptions = false;
                this.showCancelSignOptions = true;
            }
        },
        signed(response) {
            axios({
                method: 'POST',
                url: window.config.apiUrl + 'api/contract/' + this.draftContractId + '/sign',
                cancelToken: window.AuthorizationCancelSource.token,
                data: {
                    nemid_response: response
                }
            }).then(response => {
                this.$router.push('/signing-success');
                this.$router.go();
            });
        },
        error(message) {
            this.$swal(message, [], 'error');
        },
    },
    created() {
        this.draftContractId = this.$route.params.id;
        this.$store.dispatch('fetchContractForSignature', this.$route.params.id);
    },
    mounted() {
        window.axios.get('/nemid/javascript').then((response) => this.jsConfig = response.data);
        window.axios.get('/nemid/codefile').then((response) => this.cfConfig = response.data);

        axios({
            method: 'GET',
            url: window.config.apiUrl + 'api/settings'
        }).then(response => {
            if(this.$i18n.locale === 'dk') {
                this.power_supply_terms_and_conditions = response.data.power_supply.terms_and_conditions.da;
            } else {
                this.power_supply_terms_and_conditions = response.data.power_supply.terms_and_conditions.en;
            }

        }).finally(() => {
            this.loading = false;
        });
    }
}

</script>
<style lang="scss">

#nemid_iframe, #codefile_iframe {
    border: none;
}

.nemid-container {
    margin-top: 0;

    .tabs-component > ul {
        border: none;
        padding: 0 0 20px 0;
        margin: 0;
    }
}

</style>
